import {
  TTranslationAppearanceForm,
  TTranslationAppearanceTheme,
} from '@/page/general-settings/appearance/appearance.ts';

const appearanceForm: TTranslationAppearanceForm = {
  colorTheme: {
    label: 'Farebná téma',
    tooltip: 'Určuje farby Qmulus. Každý náhľad zobrazuje tému vo zvolenej hustote.',
  },
  density: {
    label: 'Hustota',
    tooltip: 'Určuje, koľko miesta Qmulus necháva medzi prvkami. Kompaktná zobrazí viac obsahu naraz, široká dá prvkom viac priestoru.',
  },
  locale: {
    label: 'Jazyk',
    tooltip: 'Umožňuje vybrať požadovaný jazyk a regionálne nastavenia používateľského rozhrania.',
  },
  fontSize: {
    label: 'Škálovanie stránky',
    tooltip: 'Umožňuje nastaviť veľkosť písma a prvkov používateľského rozhrania.',
  },
  chartTimeFormat: {
    label: 'Formát času grafu',
    tooltip: 'Určuje spôsob zobrazovania dátumov a časových pečiatok na osi X grafov.',
  },
  unitSystem: {
    label: 'Sústava jednotiek',
    tooltip: 'Vyberte preferované merné jednotky (napr. metrické alebo imperiálne) na zobrazovanie hodnôt',
  },
  scaleOption: {
    label: 'Mierka rozloženia',
    tooltip: 'Určuje, ako sa má zobrazovať mierka rozloženia obchodu.',
  },
  showOnlyAvailableApps: {
    label: 'Skryť neaktívne aplikácie?',
    tooltip: 'Skryje aplikácie, ktoré nie sú k dispozícii, aby bolo používateľské rozhranie prehľadnejšie.',
  },
  hasOptedOutOfReleaseHighlights: {
    label: 'Zobraziť novinky po aktualizáciách?',
    tooltip: 'Po aktualizácii raz zobrazí novinky nových verzií Qmulus. Sú vždy dostupné na stránke, ktorá sa otvorí po kliknutí na číslo verzie v používateľskej ponuke.',
  },
};

const appearanceTheme: TTranslationAppearanceTheme = {
  colorThemeOption: {
    'qmulus-light': 'Qmulus svetlá',
    'qmulus-g10': 'Qmulus sivá 10',
    'qmulus-g90': 'Qmulus sivá 90',
    'qmulus-dark': 'Qmulus tmavá',
    'aichelin-light': 'Aichelin svetlá',
    'aichelin-dark': 'Aichelin tmavá',
    'pt9000-modern': 'PT9000 moderná',
    'pt9000': 'PT9000',
    'galaxy-desert': 'Galaxy púštna',
    'galaxy-snow': 'Galaxy snehová',
    'galaxy-void': 'Galaxy vákuová',
    'galaxy-ember': 'Galaxy žeravá',
  },
  densityOption: {
    compact: 'Kompaktná',
    regular: 'Bežná',
    wide: 'Široká',
  },
};

export default {
  subline: 'Zmeniť vzhľad Qmulus',
  appearanceForm,
  appearanceTheme,
};
